const R = {
  Normal: "NORMAL",
  Group: "GROUP",
  Gco: "GCO",
  Sop: "SOP",
  Proxy: "PROXY",
  Registration: "REGISTRATION",
  Renewal: "RENEWAL",
  Upgrade: "UPGRADE",
  Downgrade: "DOWNGRADE",
  Digital: "DIGITAL",
  Wht: "WHT",
  Replacement: "REPLACEMENT",
  Amc: "AMC",
  Service: "SERVICE",
  CustomerService: "CUSTOMER_SERVICE",
  AutoRenewalImpersonation: "AUTO_RENEWAL_IMPERSONATION",
  RandomStaff: "RANDOM_STAFF"
};
export {
  R as e
};
//# sourceMappingURL=Classification-6901cb71.mjs.map
